import Permit from "@/utils/permit.js";

let menus = []
menus.push({ key: 'Dashboard', label: '主工作台', path: '/normal/dashboard', icon: 'dashboard' })
menus.push({ key: 'fnReports', label: '财务报表', path: '/fnReport/fn-reports', icon: 'report' })


let verify = { key: 'verify', label: '财务审核', icon: 'verify', children: [] }
menus.push(verify)
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('oms')) {
  // && Permit.currentTenant().config.financeVerifyStrict == true && Permit.canActions('bargainFinanceVerify')
  verify.children.push({ key: 'fnReportsVerifiesBargains', label: '订单', path: '/fnReport/fn-reports/verifies/bargains' })
}
if (['charge'].includes(Permit.edition()) && (Permit.extendModels().includes('lmsC') || Permit.extendModels().includes('lmsE') || Permit.extendModels().includes('lmsO')) && Permit.currentTenant().config.deliveryStrict == true && Permit.canActions('bargainDeliveryVerify')) {
  verify.children.push({ key: 'fnReportsVerifiesPendingDelivers', label: '欠款发货', path: '/fnReport/fn-reports/verifies/pending-delivers' })
}
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('oms') && Permit.canActions('customerBalanceVerify')) {
  verify.children.push({ key: 'fnReportsVerifiesCustomerBalances', label: '客户充值', path: '/fnReport/fn-reports/verifies/customer-balances' })
}
if (['charge', 'af'].includes(Permit.edition()) && Permit.extendModels().includes('report') && Permit.canActions('settlementManageCustomer')) {
  menus.push({ key: 'fnReportsCustomerSettlements', label: '客户账单', path: '/fnReport/fn-reports/customer-settlements', icon: 'customer-settlements' })
}
if (['charge', 'bf'].includes(Permit.edition()) && Permit.extendModels().includes('report') && Permit.canActions('settlementManageSupplier')) {
  menus.push({ key: 'fnReportsSupplierSettlements', label: '外采账单', path: '/fnReport/fn-reports/supplier-settlements', icon: 'supplier-settlements' })
}
// if (['charge', 'af'].includes(Permit.edition()) && (Permit.extendModels().includes('lmsC') || Permit.extendModels().includes('lmsE') || Permit.extendModels().includes('lmsO')) && Permit.canActions('settlementManageDelivery')) {
//   let deliverSettlements = { key: 'deliverSettlements', label: '发货账单', icon: 'deliver-settlements', children: [] }
//   menus.push(deliverSettlements)
//   if (Permit.extendModels().includes('lmsE')) {
//     deliverSettlements.children.push({ key: 'fnReportsDeliverSettlementsExpresses', label: '国内快递', path: '/fnReport/fn-reports/deliver-settlements/expresses' })
//   }
//   if (Permit.extendModels().includes('lmsC')) {
//     deliverSettlements.children.push({ key: 'fnReportsDeliverSettlementsAgents', label: '国际快递', path: '/fnReport/fn-reports/deliver-settlements/agents' })
//   }
//   if (Permit.extendModels().includes('lmsO')) {
//     deliverSettlements.children.push({ key: 'fnReportsDeliverSettlementsCarry', label: '送货', path: '/fnReport/fn-reports/deliver-settlements/carry' })
//   }
// }
if (['charge', 'af'].includes(Permit.edition()) && (Permit.extendModels().includes('lmsC') || Permit.extendModels().includes('lmsE') || Permit.extendModels().includes('lmsO')) && Permit.canActions('settlementManageDelivery')) {
  let deliverSettlements = { key: 'deliverChecks', label: '发货对帐', icon: 'deliver-settlements', children: [] }
  menus.push(deliverSettlements)
  // if (Permit.extendModels().includes('lmsE')) {
  //   deliverSettlements.children.push({ key: 'fnReportsDeliverSettlementsExpresses', label: '国内快递', path: '/fnReport/fn-reports/deliver-settlements/expresses' })
  // }
  if (Permit.extendModels().includes('lmsC')) {
    deliverSettlements.children.push({ key: 'fnReportsDeliverChecksAgents', label: '国际快递', path: '/fnReport/fn-reports/deliver-checks/agents' })
  }
  // if (Permit.extendModels().includes('lmsO')) {
  //   deliverSettlements.children.push({ key: 'fnReportsDeliverSettlementsCarry', label: '送货', path: '/fnReport/fn-reports/deliver-settlements/carry' })
  // }
}
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('mms') && Permit.canActionsChargeEdition('mmsSettlementManageProcure')) {
  menus.push({ key: 'fnReportsMaterialSettlements', label: '物料账单', path: '/fnReport/fn-reports/material-settlements', icon: 'material-settlements' })
}
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('mes') && Permit.canActionsChargeEdition('mesSettlementsOrders')) {
  menus.push({ key: 'fnReportsFactorySettlements', label: '生产账单', path: '/fnReport/fn-reports/factory-settlements', icon: 'factory-settlements' })
}
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('mes') && Permit.canActionsChargeEdition('mesSalary')) {
  menus.push({ key: 'fnReportsWorkerSalaries', label: '工人工资单', path: '/fnReport/fn-reports/worker-salaries', icon: 'salaries' })
}
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('oms') && Permit.canActionsChargeEdition('saleSettlement')) {
  menus.push({ key: 'fnReportsSaleSettlements', label: '业绩结算', path: '/fnReport/fn-reports/sale-settlements', icon: 'sale-settlements' })
}
export default {
  items: menus.filter(menu => !menu.children || (menu.children && menu.children.length != 0)),
};